import { css } from 'lit';
export const radioGroupStyles = css `
    :host {
        display: block;
    }

    .hlx-form-control {
        border: none;
    }

    .hlx-radio-group {
        display: flex;
    }

    .hlx-radio-group-column {
        flex-direction: column;
        gap: var(--hlx-spacing-lg);
    }

    .hlx-radio-group.hlx-radio-group-row {
        display: flex;
        flex-wrap: wrap;
        gap: var(--hlx-spacing-lg);
    }

    .hlx-form-control.hlx-form-control-has-label .legend {
        display: none;
    }
    .hlx-form-control.hlx-form-control-has-label .legend {
        display: block;
        margin-bottom: var(--hlx-spacing-md);
    }

    .hlx-form-control-label {
        display: block;
    }

    .hlx-form-control-description {
        display: block;
    }

    /* override default top margin for radio-group */
    .hlx-radio-group-error {
        padding-top: var(--hlx-spacing-md);
        margin-top: var(--hlx-spacing-md) !important;
    }

    .hlx-form-control-disabled .legend,
    .hlx-form-control-disabled .hlx-form-control-label {
        color: var(--hlx-input-text-color-disabled);
    }
`;
//# sourceMappingURL=radio-group.styles.js.map